import { cn } from '@change/ds-utils';

import { Button, Image } from '@change/ds-core-ui/next';

import { Translate, useI18n } from '@change-corgi/core/react/i18n';
import { RadioGroup } from '@change-corgi/design-system-legacy/components/forms';

import { ScrollContainer } from 'src/app/shared/components/ScrollContainer';

import { RadioCard } from '../../../RadioCard';
import type { Template } from '../../hooks/useDownloadFlyerModalBody/types';

import { useChooseFlyerTemplateForm } from './hooks';

type Props = {
	templates: Template[];
};

export function FlyerDownloadForm({ templates }: Props) {
	const { translate } = useI18n();
	const { data, actions } = useChooseFlyerTemplateForm(templates);
	return (
		<form data-qa="choose-flyer-modal-form" className="flex flex-col gap-4" onSubmit={actions.downloadFlyerTemplate}>
			<RadioGroup
				data-qa="flyer-templates-radio-group"
				name="flyer-templates"
				aria-label={translate(
					'corgi.petition.starter_dashboard_v2.grow_petition.share_petition_offline.flyer_modal.radio_label',
				)}
				onChange={actions.onInputChange}
			>
				<ScrollContainer
					as="div"
					className={cn('[&>ul]:grid', '[&>ul>li]:p-2', '[&>ul>li]:pb-4', '[&>ul]:gap-0', {
						'[&_ul]:grid-cols-[repeat(auto-fill,minmax(282px,1fr))]': templates.length > 2,
						'[&>ul]:grid-cols-2': templates.length <= 2,
					})}
				>
					{templates.map((template) => (
						<RadioCard
							key={template.name}
							data-qa={`${template.name}-option`}
							className="box-border"
							value={template.name}
							label={
								<picture
									sx={{
										display: 'flex',
										aspectRatio: '180/233',
										minWidth: 262,
										maxHeight: 392,
										padding: '8px 8px 0',
										backgroundColor: 'primary-greyBackground',
									}}
								>
									<source type="image/webp" srcSet={template.images.webp.srcset} />
									<Image
										src={template.images.png.src}
										alt={template.images.alt}
										srcSet={template.images.png.srcset}
										onError={template.images.onError}
										className="aspect-auto"
										sx={{ borderRadius: 'standard' }}
									/>
								</picture>
							}
						></RadioCard>
					))}
				</ScrollContainer>
			</RadioGroup>
			<Button
				disabled={data.disabled || data.loading}
				type="submit"
				data-qa="download-poster-button"
				variant="primary"
				size="small"
				// Need bottom margin to allow focus ring to be visible when the button is focused
				className="mb-[5px] box-border self-end"
			>
				<Translate value="corgi.petition.starter_dashboard_v2.grow_petition.share_petition_offline.flyer_modal.download_button_posters" />
			</Button>
		</form>
	);
}
